
/* eslint-disable react-hooks/exhaustive-deps */
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
import { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import AccessControl from "../functional/AccessControl";
import BasicCrudScreenActionItemLayout from "../screenTypes/layout/BasicCrudScreenActionItemLayout";

import notificationState from "../../states/notificationState";
import { useSetRecoilState } from "recoil";
import UpdateRecordButton from "../input/UpdateRecordButton";
import DeleteRecordButton from "../input/DeleteRecordButton";
import SaveToExcelButton from "../input/SaveToExcelButton";
import { debounce } from "lodash";
import { ReflexContainer } from 'react-reflex';
import { ReflexElement } from 'react-reflex';
import { ReflexSplitter } from 'react-reflex';
import TkElectrodeOrderPurchaseDetail from './TkElectrodeOrderPurchaseDetail';
import layoutConf from "../../config/layoutConf";
import TkElectrodeOrderPurchaseDetailOrderBuyCreateButton from './../input/TkElectrodeOrderPurchaseDetailOrderBuyCreateButton';
import getSchema from './../../lib/api/getSchema';

function TkElectrodeOrderPurchaseDetailOrder(props) {

    const id = "TkElectrodeOrderPurchaseDetailOrder"

    const table = "TkElectrodeOrderPurchaseDetailOrder"

    const view = "TkVwElectrodeOrderPurchaseDetailOrderBuy"

    const { onSelectMst } = props;
    const [grid, setGrid] = useState();

    const [onSelectOrderBuy, setOnSelectOrderBuy] = useState();

    const { t } = useTranslation();

    const [schema, setSchema] = useState();

    const [api, setApi] = useState();

    const [disabled, setDisabled] = useState(false);

    const [isEmpty, setIsEmpty] = useState();


    const setNotification = useSetRecoilState(notificationState);

    useEffect(() => {

        if (api) {

            api.refresh();

        }

        if (onSelectMst?.electrodeId) {
            setDisabled(false)
        } else {
            setDisabled(true)
        }

    }, [onSelectMst?.electrodeId]);

    useEffect(() => {
        (async () => {
            let schema = await getSchema("TkElectrodeOrderPurchaseDetailOrder");

            setSchema(schema);
        })();
    }, [])

    useEffect(() => {

        (async () => {

            if (grid) {

                grid.selectionChanged.addHandler(debounce((grid, event) => {

                    if (grid.selectedItems && grid.selectedItems[0]) {

                        setOnSelectOrderBuy(grid.selectedItems[0])

                    } else {

                        setOnSelectOrderBuy([]);

                    };

                }), 10);

                grid.itemsSourceChanged.addHandler(debounce((grid, event) => {

                    if (grid.selectedItems && grid.selectedItems[0]) {

                        setOnSelectOrderBuy(grid.selectedItems[0])

                    } else {

                        setOnSelectOrderBuy([]);

                    };

                }), 10);
            }

        })()

    }, [grid])

    const onLoadData = (data) => {

        setIsEmpty(data.length < 1 ? true : false)

    }

    const onInitialized = grid => {

        setGrid(grid);

    };

    const onApiInitialized = (api) => {

        setApi(api);

    };

    const notifySuccess = (msg) => {

        setNotification({
            severity: "success",
            msg: msg,
            open: true,
        });

    };

    const onSuccess = (msg) => {

        notifySuccess(msg);

    };

    const notifyFailure = (msg) => {

        setNotification({
            severity: "error",
            msg: msg,
            open: true,
        });

    };

    const onFailure = (reason) => {

        notifyFailure(reason.response ? reason.response.data : reason);

    };

    const notifyWarning = (msg) => {

        setNotification({
            severity: "warning",
            msg: msg,
            open: true,
        });

    };

    const onNotifyWarning = (msg) => {

        notifyWarning(msg);

    };

    const onModifyViewUrl = (url) => {
        return url + "/" + onSelectMst?.electrodeId
    }

    return (
        <>

            <ReflexContainer orientation="vertical">
                <ReflexElement>
                    <BasicCrudScreenType
                        id={id}
                        headerTitle={t("term.tkElectrodeOrderPurchaseDetailOrderBuyer")}
                        table={table}
                        view={view}
                        onInitialized={onInitialized}
                        onApiInitialized={onApiInitialized}
                        onLoadData={onLoadData}
                        exportFormatItem={() => { }}
                        noCreate
                        noEdit
                        noDelete
                        noExcel
                        onModifyViewUrl={onModifyViewUrl}
                        onAppendButtonInFrontOfSearch={
                            () => (
                                <>
                                    <BasicCrudScreenActionItemLayout>

                                        <AccessControl accessTarget={schema && schema.name} accessMethod="POST">
                                            <TkElectrodeOrderPurchaseDetailOrderBuyCreateButton
                                                id={id}
                                                schema={schema}
                                                refresh={api}
                                                onSuccess={onSuccess}
                                                electrodeId={onSelectMst?.electrodeId}
                                                onSelectOrderBuy={onSelectOrderBuy}
                                                disabled={disabled}
                                            />
                                        </AccessControl>

                                        <AccessControl accessTarget={schema && schema.name} accessMethod={schema && (schema.updateWithPatch ? "PATCH" : "PUT")}>
                                            <UpdateRecordButton
                                                id={id}
                                                schema={schema}
                                                grid={grid}
                                                refresh={api}
                                                disabled={isEmpty}
                                                onSuccess={onSuccess}
                                            />
                                        </AccessControl>

                                        <AccessControl accessTarget={schema && schema.name} accessMethod="DELETE">
                                            <DeleteRecordButton
                                                id={id}
                                                schema={schema}
                                                grid={grid}
                                                refresh={api}
                                                color="secondary"
                                                disabled={isEmpty}
                                                onSuccess={onSuccess}
                                                onFailure={onFailure}
                                                onPartialFailure={onNotifyWarning}
                                            />
                                        </AccessControl>

                                        <AccessControl accessTarget={schema && schema.name} accessMethod="SAVETOEXCEL">
                                            <SaveToExcelButton
                                                id={id}
                                                grid={grid}
                                                view={view}
                                                color="primary"
                                                exportFormatItem={() => { }}
                                                disabled={isEmpty}
                                            />
                                        </AccessControl>
                                    </BasicCrudScreenActionItemLayout>
                                </>
                            )
                        }
                    />
                </ReflexElement>
                <ReflexSplitter style={{ width: layoutConf.reflex.splitterWidth }} />
                <ReflexElement>

                    <TkElectrodeOrderPurchaseDetail
                        onSelectMst={onSelectMst}
                        onSelectOrderBuy={onSelectOrderBuy}
                    />
                </ReflexElement>
            </ReflexContainer>


        </>

    );

}

export default TkElectrodeOrderPurchaseDetailOrder;
